// dashboardReducer.js
import {
  FETCH_CANDIDATE_DETAILS_REQUEST,
  FETCH_CANDIDATE_DETAILS_SUCCESS,
  FETCH_CANDIDATE_DETAILS_FAILURE,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  data: null,
  error: null,
  // is_daily_visit: 0,
};

const fetchCandidateDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CANDIDATE_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_CANDIDATE_DETAILS_SUCCESS:
      console.log("gggggg", action.payload);
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        // is_daily_visit: action.payload.data.is_daily_visit,
        error: null,
      };
    case FETCH_CANDIDATE_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default fetchCandidateDetailReducer;
